import { View } from './view'

export const MainPageV2 = View
